/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiBulkCreateExpenseSplitRequest,
  ApiBulkDeleteExpenseSplitRequest,
  ApiBulkUpdateExpenseSplitAmountFieldsRequest,
  ApiBulkUpdateExpenseSplitBookingTextRequest,
  ApiBulkUpdateExpenseSplitCostCarrierRequest,
  ApiBulkUpdateExpenseSplitCostCenterRequest,
  ApiBulkUpdateExpenseSplitDimensionMappingRequest,
  ApiBulkUpdateExpenseSplitExpenseAccountRequest,
  ApiBulkUpdateExpenseSplitVatRequest,
  ApiCreateInitialExpenseSplitRequest,
  SplitParentExpenseDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiExpenseSplitController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseVat
   * @request PUT:/api/v1/expense/{expenseId}/splits/vat
   */
  bulkUpdateSplitExpenseVat = (
    expenseId: string,
    data: ApiBulkUpdateExpenseSplitVatRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/vat`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseVatPath = '/v1/expense/${expenseId}/splits/vat'
  static bulkUpdateSplitExpenseVatMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseExpenseAccount
   * @request PUT:/api/v1/expense/{expenseId}/splits/expense-account
   */
  bulkUpdateSplitExpenseExpenseAccount = (
    expenseId: string,
    data: ApiBulkUpdateExpenseSplitExpenseAccountRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/expense-account`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseExpenseAccountPath =
    '/v1/expense/${expenseId}/splits/expense-account'
  static bulkUpdateSplitExpenseExpenseAccountMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseDimensionMapping
   * @request PUT:/api/v1/expense/{expenseId}/splits/dimension-mapping/{dimensionId}
   */
  bulkUpdateSplitExpenseDimensionMapping = (
    expenseId: string,
    dimensionId: string,
    data: ApiBulkUpdateExpenseSplitDimensionMappingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/dimension-mapping/${dimensionId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseDimensionMappingPath =
    '/v1/expense/${expenseId}/splits/dimension-mapping/${dimensionId}'
  static bulkUpdateSplitExpenseDimensionMappingMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseCostCenter
   * @request PUT:/api/v1/expense/{expenseId}/splits/cost-center
   */
  bulkUpdateSplitExpenseCostCenter = (
    expenseId: string,
    data: ApiBulkUpdateExpenseSplitCostCenterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/cost-center`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseCostCenterPath = '/v1/expense/${expenseId}/splits/cost-center'
  static bulkUpdateSplitExpenseCostCenterMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseCostCarrier
   * @request PUT:/api/v1/expense/{expenseId}/splits/cost-carrier
   */
  bulkUpdateSplitExpenseCostCarrier = (
    expenseId: string,
    data: ApiBulkUpdateExpenseSplitCostCarrierRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/cost-carrier`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseCostCarrierPath = '/v1/expense/${expenseId}/splits/cost-carrier'
  static bulkUpdateSplitExpenseCostCarrierMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseBookingText
   * @request PUT:/api/v1/expense/{expenseId}/splits/booking-text
   */
  bulkUpdateSplitExpenseBookingText = (
    expenseId: string,
    data: ApiBulkUpdateExpenseSplitBookingTextRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/booking-text`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseBookingTextPath = '/v1/expense/${expenseId}/splits/booking-text'
  static bulkUpdateSplitExpenseBookingTextMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkUpdateSplitExpenseAmountFields
   * @request PUT:/api/v1/expense/{expenseId}/splits/amount-fields
   */
  bulkUpdateSplitExpenseAmountFields = (
    expenseId: string,
    data: ApiBulkUpdateExpenseSplitAmountFieldsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/amount-fields`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateSplitExpenseAmountFieldsPath = '/v1/expense/${expenseId}/splits/amount-fields'
  static bulkUpdateSplitExpenseAmountFieldsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkCreateSplitExpense
   * @request POST:/api/v1/expense/{expenseId}/splits
   */
  bulkCreateSplitExpense = (
    expenseId: string,
    data: ApiBulkCreateExpenseSplitRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkCreateSplitExpensePath = '/v1/expense/${expenseId}/splits'
  static bulkCreateSplitExpenseMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name CreateInitialSplitExpense
   * @request POST:/api/v1/expense/{expenseId}/splits/initial
   */
  createInitialSplitExpense = (
    expenseId: string,
    data: ApiCreateInitialExpenseSplitRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/initial`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createInitialSplitExpensePath = '/v1/expense/${expenseId}/splits/initial'
  static createInitialSplitExpenseMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-split-controller
   * @name BulkDeleteSplitExpenses
   * @request POST:/api/v1/expense/{expenseId}/splits/bulk-delete
   */
  bulkDeleteSplitExpenses = (
    expenseId: string,
    data: ApiBulkDeleteExpenseSplitRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitParentExpenseDto, any>({
      path: `/v1/expense/${expenseId}/splits/bulk-delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkDeleteSplitExpensesPath = '/v1/expense/${expenseId}/splits/bulk-delete'
  static bulkDeleteSplitExpensesMethod = 'POST'
}
